<template>
  <v-dialog :value="value" persistent width="500">
  <v-card v-if="store">
    <v-card-title :class="title">Store Info</v-card-title>
      <v-card-text class="pa-o ma-0">
        <v-row v-for="(row, index) in getRows()" :key="index" align="center" dense>
          <v-col v-for="(obj, index) in row" :key="index">
            <v-list-item dense>
              <v-list-item-content>
                <v-list-item-subtitle :class="label" class="black--text">{{obj.label}}</v-list-item-subtitle>
                <v-list-item-title :class="body">
                  {{obj.value}}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn :class="body" outlined rounded text @click="$emit('update:value', false)">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { displayHelpers } from '@/mixins/display-helpers'

export default {
  name: 'StoreInfo',

  props: {
    value: Boolean,
    storeNumber: String
  },

  mixins: [displayHelpers],

  data: () => ({
    store: {}
  }),

  computed: {
    storeKeys () {
      return [
        { label: 'Store Number', value: this.store.StoreNumber },
        { label: 'Store Name', value: this.store.StoreName },
        { label: 'Street', value: this.store.Street },
        { label: 'City', value: this.store.City },
        { label: 'State', value: this.store.State },
        { label: 'Zipcode', value: this.store.Zipcode },
        { label: 'County', value: this.store.County },
        { label: 'Division', value: this.store.Division },
        { label: 'District', value: this.store.District },
        { label: 'DSD Zone Code', value: this.store.DSDZoneCode },
        { label: 'Price Zone', value: this.store.PriceZone },
      ]
    }
  },

  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) this.getStoreInfo()
      }
    }
  },

  methods: {
    getRows () {
      const numCols = 2
      const rows = this.storeKeys.reduce((acc, curr, index) => {
        const i = index
        const row = Math.floor(i / numCols)
        const mod = i % numCols
        if (mod === 0) {
          acc.push([])
        }
        acc[row].push(curr)
        return acc
      }, [])
      return rows
    },

    async getStoreInfo () {
      await this.$stores.getStoreInfo(this.storeNumber)
        .then(res => {
          this.store = res.data[0]
        })
    }
  }
}
</script>
